import { SOMETHING_WENT_WRONG } from "@Services/constants";
import { XmlToJson, convertXmlDataToTasks } from "./XmlUtils";

export const convertMspXmlToJson = (data, scheduleId) => {
  const json = XmlToJson(data);
  if (typeof json == "object") {
    try {
      const RelationshipConvert = {
        0: "FF",
        1: "FS",
        2: "SF",
        3: "SS",
      };

      const Tasks = json.Project.Tasks.Task;
      Tasks.shift();
      const tempData = [];
      const calendar = json.Project.Calendars.Calendar;
      const taskUidAndIdMapper = {};
      const wbsAndUidMapper = {};
      const dayCalculator = json.Project.MinutesPerWeek * json.Project.WorkFormat;
      const slackCalculator = 4800;

      Tasks.map((element) => {
        if (element.Duration) {
          let hours = 0;
          let minutes = 0;
          let seconds = 0;
          const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
          const matches = element.Duration.match(regex);
          // const matches = element.Duration.match(/(\d+H)?(\d+M)?(\d+S)?/);

          if (matches[1]) hours = parseInt(matches[1]);
          if (matches[2]) minutes = parseInt(matches[2]);
          if (matches[3]) seconds = parseInt(matches[3]);
          element.Duration =
            (hours * 3600 + minutes * 60 + seconds) /
            (json.Project.MinutesPerday ? json.Project.MinutesPerday * 60 : 28800);
        }
        taskUidAndIdMapper[element.UID] = element.ID;
        if (element.WBS || element.WBS == 0) {
          wbsAndUidMapper[element.WBS] = element.UID;
        }

        tempData.push({
          TaskId: String(element.UID),
          TaskName: element.Name,
          // Duration: element.Duration || '',
          Duration: "",
          Start: element.Start ? element.Start : "",
          Finish: element.Finish ? element.Finish : "",
          WBSPath: "",
          PredecessorDetails: "",
          ActualStart: element.ActualStart ? element.ActualStart : "",
          ActualFinish: element.ActualFinish ? element.ActualFinish : "",
          PlannedStart: element.Baseline ? element.Baseline.Start : "",
          PlannedFinish: element.Baseline ? element.Baseline.Finish : "",
          PredecessorLink: element.PredecessorLink || "",
          WBS: element.WBS ? String(element.WBS) : "",
          WBSCode: String(element.ID),
          critical: element.Critical ? "Yes" : "No",
          totalSlack: element.TotalSlack / slackCalculator || 0,
        });
      });

      tempData.map((element) => {
        if (element.PredecessorLink) {
          let content;

          if (element.PredecessorLink.length) {
            element.PredecessorLink.map((data, index) => {
              const taskIndex = taskUidAndIdMapper[data.PredecessorUID];
              const type = RelationshipConvert[data.Type];
              const lag = data.LinkLag;
              const lagOperator = lag >= 0 ? "+" : "";
              // const lagType = LagTypeConvert[data.LagFormat];
              if (index == 0) {
                content = `${taskIndex}${type}${lagOperator}${lag / dayCalculator} days`;
              } else {
                content = `${content},${taskIndex}${type}${lagOperator}${lag / dayCalculator} days`;
              }
            });
          } else {
            content = `${taskUidAndIdMapper[element.PredecessorLink.PredecessorUID]}${
              RelationshipConvert[element.PredecessorLink.Type]
            }${element.PredecessorLink.LinkLag >= 0 ? "+" : ""}${element.PredecessorLink.LinkLag / dayCalculator} days`;
          }
          element.PredecessorDetails = content;
        }
        if (element.WBS) {
          if (element.WBS.split(".").length > 1) {
            const WbsArray = element.WBS.split(".");
            element.WBSPath = wbsAndUidMapper[WbsArray.slice(0, -1).join(".")];
          }
        }
      });
      return { calendar, data: convertXmlDataToTasks(tempData, scheduleId) };
    } catch (e) {
      console.log(e);
      return SOMETHING_WENT_WRONG;
    }
  } else {
    return json;
  }
};
